var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramCarInsurance40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CarRepair40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 3.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pictogramStandardVehicle64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.375,15.75 L30.375,15.75 C31.6176407,15.75 32.625,16.7573593 32.625,18 L32.625,22.5 L5.625,22.5 C4.38235931,22.5 3.375,21.4926407 3.375,20.25 L3.375,15.75 Z",
    id: "body",
    stroke: "#4F4D4C",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bonnet",
    transform: "translate(27.446002, 13.295272) rotate(-45.000000) translate(-27.446002, -13.295272) translate(22.664752, 12.170272)",
    stroke: "#4F4D4C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.27897692e-13,0 C1.61836243,0 4.05586243,0 7.3125,0 C8.55514069,0 9.5625,1.00735931 9.5625,2.25",
    id: "Rectangle-38"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.6875,22.5 C28.6875,24.0533876 27.4281874,25.3125 25.8752636,25.3125 C24.3218126,25.3125 23.0625,24.0533876 23.0625,22.5 C23.0625,20.9466124 24.3218126,19.6875 25.8752636,19.6875 C27.4281874,19.6875 28.6875,20.9466124 28.6875,22.5 L28.6875,22.5 Z",
    id: "wheel",
    stroke: "#4F4C4D",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375,22.5 C12.375,24.0533876 11.1156874,25.3125 9.56276359,25.3125 C8.00931262,25.3125 6.75,24.0533876 6.75,22.5 C6.75,20.9466124 8.00931262,19.6875 9.56276359,19.6875 C11.1156874,19.6875 12.375,20.9466124 12.375,22.5 L12.375,22.5 Z",
    id: "wheel",
    stroke: "#4F4C4D",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Roof",
    stroke: "#4F4C4D",
    points: "10.8627649 10.125 18.9497351 10.125 23.625 15.75 6.1875 15.75"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramCarInsurance40);
export default __webpack_public_path__ + "static/media/pictogramCarInsurance40.ba804c7477ed3ea75673c5ccf517c0e1.svg";
export { ForwardRef as ReactComponent };